import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./page/Login/Login";
import Dashboard from "./page/Dashboard/Dashboard";
import { AppProvider } from "./context/AppContext/AppContext";
import ProfilePage from "./page/Profile/Profile";
import Sidebar from "./component/Sidebar/Sidebar";
import LandingPage from "./page/LandingPage/LandingPage";
import PrivateRoute from './component/PrivateRoute/PrivateRoute';

function App() {
  return (
    <div className="App">
      <AppProvider>
        <div className="d-flex" >
          <Router>
          <Sidebar/>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<ProfilePage />} />
              </Route>
            </Routes>
          </Router>
        </div>
      </AppProvider>
    </div>
  );
}

export default App;
